export function normalizeWhitespace(value = "") {
  return String(value || "").replace(/\s+/g, " ").trim();
}
